import React from 'react';
import {ReactComponent as ToReleaseIcon} from '../../../../assets/icons/to-release.svg';
import AvatarSpectator from '../../../../assets/images/avatars/avatar-spectator.png';
import AvatarUser from '../../../../assets/images/avatars/avatar-users.png';
import {ReactComponent as UseAddIcon} from '../../../../assets/icons/user-add.svg';
import {ReactComponent as ToDeleteIcon} from '../../../../assets/icons/delete.svg';
import {ReactComponent as SettingsIcon} from '../../../../assets/images/profile/Menu/project3.svg';
import './Employees.scss';
import {IconButtonMUI} from '../../../../shared';
import {useTranslation} from 'react-i18next';
import {useSelector} from "react-redux";

const Employees = ({
                       name,
                       position,
                       status,
                       avatar,
                       id,
                       handleId,
                       employeeId,
                       onFire,
                       onReturn,
                       onRemoveEmployees,
                       editPermission,
                       removePermission = false,
                       phone,
                       email,
                       onEditUser,
                       editPerson,
                       returnEmployeePermission = false,
                       fireEmployeePermission = false
                   }) => {
    const profileMe = useSelector((state) => state.profile.profileMe);

    const isMe = profileMe?.id === id;

    const {t} = useTranslation();

    return (
        <div className='projects-employees' key={id}>
            <div className='projects-employees__info'>
                <div className='projects-employees__info-avatar'>
                    {avatar ? (
                        <img className='avatar-image' src={avatar} alt={name}/>
                    ) : position === 'spectator' ? (
                        <img className='avatar-image' src={AvatarSpectator} alt={name}/>
                    ) : (
                        <img className='avatar-image' src={AvatarUser} alt={name}/>
                    )}

                    {status === 'active' ? <div className='status active'/> : <div className='status'/>}
                </div>
                <div className='projects-employees__info-user'>
                    <div className='projects-employees__info-name' onClick={handleId}>
                        {name}
                    </div>
                    <div className='projects-employees__info-role'>{position}</div>
                </div>
            </div>

            <div className='projects-employees__details-btn-wrapper'>
                {onRemoveEmployees && (removePermission) && !isMe && (
                    <div className='projects-employees__details-btn' onClick={() => onRemoveEmployees(employeeId)}>
                        <IconButtonMUI color={'inherit'} title={t('EmployeesInner.remove')}>
                            <ToDeleteIcon/>
                        </IconButtonMUI>
                    </div>
                )}

                {status === 'active' && fireEmployeePermission && !isMe && (
                    <div className='projects-employees__details-btn' onClick={() => onFire(employeeId)}>
                        <IconButtonMUI color={'inherit'} title={t('EmployeesInner.fire')}>
                            <ToReleaseIcon/>
                        </IconButtonMUI>
                    </div>
                )}

                {status === 'fired' && returnEmployeePermission && !isMe && (
                    <div className='projects-employees__details-btn' onClick={() => onReturn(employeeId)}>
                        <IconButtonMUI color={'inherit'} title={t('EmployeesInner.return')}>
                            <UseAddIcon/>
                        </IconButtonMUI>
                    </div>
                )}
                {editPerson && (
                    <div
                        className='projects-employees__details-btn'
                        onClick={() =>
                            onEditUser({
                                id: id,
                                name: name,
                                avatar: avatar,
                                email: email,
                                phone: phone
                            })
                        }
                    >
                        <IconButtonMUI color={'inherit'} title={t('dictionaries.edit')}>
                            <SettingsIcon/>
                        </IconButtonMUI>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Employees;
